import React, { useRef, useEffect, useState } from 'react';
import { Alert, Card, Col, Form, Row, Stack, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import { ADD, AXE, CYL, PD, SPH } from '../Eyetest/options';
import {
    colorA1,
    colorA2,
    colorA34,
    frameTypeA1,
    IndiceA1,
    Indiceothers,
    LensTypeDetailsA1,
    LensTypeDetailsB2,
    LensTypeDetailsB34,
    MontureA1,
    MontureB1,
    Monture2,
    Monture34,
    Nooption,
    Supplier,
    TiersPayant,
    TreatmentA1,
    Treatmentmva1,
    TreatmentSP3,
    Treatment234,
    Typedepanier,
    Typedeteinte,
    TypedeverreA1,
    TypedeverreA2,
    TypedeverreB1,
    TypedeverreB2,
    TypedeverreB34,
    TypedeverreSP3,
    Typedevision,
    Typeofpayment,
} from './orderOptions';

const CustomMenuList = (props) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollIntoView({ block: 'center' });
        }
    }, []);

    return (
        <components.MenuList {...props}>
            {props.children &&
                props.children.length > 0 &&
                props.children.map((child) => {
                    if (child?.props?.data?.value === '0.00') {
                        return (
                            <div ref={ref} key={child.key}>
                                {child}
                            </div>
                        );
                    }
                    return child;
                })}
        </components.MenuList>
    );
};
const VISION_MAP = {
    VL: ['SV', 'ASPHERIC'],
    VP: ['SV', 'ASPHERIC'],
    Progressif: ['PROG'],
    Degressif: ['DEG'],
    Bifocal: ['DOUBLE FOYER'],
    ZenView: ['ZENVIEW']
};
const filterByVisionType = (options, typeDeVision) => {
    if (!typeDeVision) return options;

    const keywords = VISION_MAP[typeDeVision];
    if (!keywords) return options;

    return options.filter(opt => {
        const label = opt.label?.toUpperCase() || '';
        return keywords.some(k => label.includes(k));
    });
};
const OrderPair = ({ addOrderConfig, setAddOrderConfig, error, isEdit }) => {
    const { t } = useTranslation();
    const MAX_PAIRS = 4;

    // Initialize showPairs based on the number of pairs in addOrderConfig
    const [showPairs, setShowPairs] = useState(() => {
        const initialShowPairs = [true, false, false, false];
        addOrderConfig.forEach((_, index) => {
            if (index < MAX_PAIRS) {
                initialShowPairs[index] = true;
            }
        });
        return initialShowPairs;
    });

    // Sync showPairs with actual orders when addOrderConfig changes (especially important for edit mode)
    useEffect(() => {
        if (isEdit && addOrderConfig.length > 0) {
            const newShowPairs = [false, false, false, false];
            addOrderConfig.forEach((_, index) => {
                if (index < MAX_PAIRS) {
                    newShowPairs[index] = true;
                }
            });
            setShowPairs(newShowPairs);
        }
    }, [addOrderConfig, isEdit]);

    const extractPrice = (str) => {
        if (!str) return 0;
        const match = str.match(/- (\d+(\.\d{1,2})?) €/);
        return match ? parseFloat(match[1]) : 0;
    };

    const calculatePrice = (item) => {
        const sum =
            extractPrice(item?.orderType) +
            extractPrice(item?.orderIndex) +
            extractPrice(item?.frameColor) +
            extractPrice(item?.lensTypeDetails) +
            extractPrice(item?.treatment) +
            extractPrice(item?.infoFrameType) +
            extractPrice(item?.frameReference);
        return sum.toFixed(2) + ' €';
    };

    const calculateTotalPrice = () => {
        let total = 0;
        addOrderConfig.forEach((item) => {
            const price = calculatePrice(item);
            total += parseFloat(price.replace(' €', ''));
        });
        return total.toFixed(2) + ' €';
    };

    const updatePriceForPair = (pairNoToUpdate) => {
        setAddOrderConfig((prevOrders) =>
            prevOrders.map((order) => {
                if (order.OrderPairNo === pairNoToUpdate) {
                    return {
                        ...order,
                        price: calculatePrice(order)
                    };
                }
                return order;
            })
        );
    };

    const handleTogglePair = (pairIndex, show) => {
        const newShowPairs = [...showPairs];

        // Update the visibility for the clicked pair
        newShowPairs[pairIndex] = show;

        // If hiding a pair, also hide all subsequent pairs
        if (!show) {
            for (let i = pairIndex + 1; i < MAX_PAIRS; i++) {
                newShowPairs[i] = false;
            }
        }

        setShowPairs(newShowPairs);

        // IMPORTANT: In edit mode, don't modify the orders array
        if (isEdit) {
            // Just update visibility, keep all existing order data
            return;
        }

        // Only for add mode: manage order creation/deletion based on visibility
        const visiblePairsCount = newShowPairs.filter(Boolean).length;

        if (visiblePairsCount < addOrderConfig.length) {
            // Remove excess orders
            const newOrders = addOrderConfig.slice(0, visiblePairsCount);
            setAddOrderConfig(newOrders);
        } else if (visiblePairsCount > addOrderConfig.length) {
            // Add new orders
            const pairsToAdd = visiblePairsCount - addOrderConfig.length;
            let newOrders = [...addOrderConfig];

            for (let i = 0; i < pairsToAdd; i++) {
                const lastOrder = newOrders[newOrders.length - 1];
                newOrders.push({
                    ...lastOrder,
                    OrderPairNo: `${newOrders.length + 1}`,
                    orderType: '',
                    orderIndex: '',
                    frameColor: '',
                    lensTypeDetails: '',
                    treatment: '',
                    infoFrameType: '',
                    frameReference: '',
                    infoSupplier: '',
                    price: '0.00 €',
                    status: 'Pending',
                    comments: '',
                    leftHeightEye: '',
                    rightHeightEye: '',
                    typeDeVision: '',
                });
            }

            setAddOrderConfig(newOrders);
        }
    };

    const handleChange = (value, name, pairNoToUpdate) => {
        setAddOrderConfig((prevOrders) =>
            prevOrders.map((order) => {
                if (order.OrderPairNo === pairNoToUpdate) {
                    const updatedOrder = { ...order, [name]: value };

                    if (name === 'lensShape') {
                        // When lensShape changes, reset dependent fields
                        updatedOrder.orderType = '';
                        updatedOrder.orderIndex = '';
                        updatedOrder.frameColor = '';
                        updatedOrder.lensTypeDetails = '';
                        updatedOrder.treatment = '';
                        updatedOrder.infoFrameType = '';
                        updatedOrder.frameReference = '';
                    }
                    if (name === 'typeDeVision') {
                        updatedOrder.orderType = ''; // reset invalid selection
                    }
                    // Update price for this pair
                    setTimeout(() => {
                        updatePriceForPair(pairNoToUpdate);
                    }, 0);

                    return updatedOrder;
                }
                return order;
            })
        );
    };

    const getPairSpecificOptions = (pairNo, optionType, currentValue) => {
        const pairIndex = parseInt(pairNo) - 1;

        // Use the lensShape from the first pair for all pairs
        const lensShape = addOrderConfig[0]?.lensShape;

        switch (optionType) {
            case 'orderType': {
                let options = Nooption;

                if (pairIndex === 0) {
                    if (lensShape === 'A') options = TypedeverreA1;
                    if (lensShape === 'Mixte Verre A') options = TypedeverreA1;
                    if (lensShape === 'B') options = TypedeverreB1;
                    if (lensShape === 'Mixte Monture A') options = TypedeverreB1;
                    if (lensShape === 'Sans Panier') options = TypedeverreB1;
                } else if (pairIndex === 1) {
                    if (lensShape === 'A' || lensShape === 'Mixte Verre A') options = TypedeverreA2;
                    if (lensShape === 'B') options = TypedeverreB2;
                    if (lensShape === 'Mixte Monture A') options = TypedeverreB2;
                    if (lensShape === 'Sans Panier') options = TypedeverreB1;
                } else {
                    if (['A', 'B', 'Mixte Verre A', 'Mixte Monture A'].includes(lensShape))
                        options = TypedeverreSP3;
                    if (lensShape === 'Sans Panier')
                        options = TypedeverreSP3;
                }

                // ✅ APPLY FILTER HERE (NEW FIX)
                return filterByVisionType(options, currentValue?.typeDeVision);
            }
            case 'orderIndex':
                if (pairIndex === 0) {
                    if (['B', 'Mixte Monture A', 'Sans Panier'].includes(lensShape)) return Indiceothers;
                    if (['A', 'Mixte Verre A'].includes(lensShape)) return IndiceA1;
                } else {
                    return Indiceothers;
                }
                return Nooption;

            case 'frameColor':
                if (pairIndex === 0) {
                    if (['B', 'Mixte Monture A', 'Sans Panier'].includes(lensShape)) return colorA34;
                    if (['A', 'Mixte Verre A'].includes(lensShape)) return colorA1;
                } else if (pairIndex === 1) {
                    if (['B', 'Mixte Monture A', 'Sans Panier'].includes(lensShape)) return colorA34;
                    if (['A', 'Mixte Verre A'].includes(lensShape)) return colorA2;
                } else {
                    return colorA34;
                }
                return Nooption;

            case 'lensTypeDetails':
                if (pairIndex === 0) {
                    if (['A', 'Mixte Verre A'].includes(lensShape)) return LensTypeDetailsA1;
                    if (['B', 'Mixte Monture A'].includes(lensShape)) return LensTypeDetailsB2;
                    if (lensShape === 'Sans Panier') return LensTypeDetailsB34;
                } else if (pairIndex === 1) {
                    if (['A', 'Mixte Verre A', 'Sans Panier'].includes(lensShape)) return LensTypeDetailsB34;
                    if (['B', 'Mixte Monture A'].includes(lensShape)) return LensTypeDetailsB2;
                } else {
                    return LensTypeDetailsB34;
                }
                return Nooption;

            case 'treatment':
                if (pairIndex === 0) {
                    if (lensShape === 'A') return TreatmentA1;
                    if (lensShape === 'Mixte Verre A') return Treatmentmva1;
                    if (['B', 'Sans Panier', 'Mixte Monture A'].includes(lensShape)) return TreatmentSP3;
                } else {
                    return Treatment234;
                }
                return Nooption;

            case 'frameType':
                return frameTypeA1;

            case 'frameReference':
                if (pairIndex === 0) {
                    if (['A', 'Mixte Monture A', 'Sans Panier'].includes(lensShape)) return MontureA1;
                    if (['B', 'Mixte Verre A'].includes(lensShape)) return MontureB1;
                } else if (pairIndex === 1) {
                    return Monture2;
                } else {
                    return Monture34;
                }
                return Nooption;

            default:
                return Nooption;
        }
    };

    return (
        <>
            {addOrderConfig.map((item, index) => (
                <Card
                    key={index}
                    className="mt-4 order_wrapper"
                    style={{ display: showPairs[index] ? 'block' : 'none' }}
                >
                    <Card.Body className="modal_form">
                        {index === 0 && (
                            <Card className="mb-3 eye_test_symtoms">
                                <Card.Body className="modal_form">
                                    <Card.Title className="add_eye_title">
                                        <h4 className="mb-3">
                                            {t('finalOpticianRecommendation')}
                                        </h4>
                                    </Card.Title>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>SPH</th>
                                                <th>CYL</th>
                                                <th>AXE</th>
                                                <th>ADD</th>
                                                <th>PD</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>OD</td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianRightSPH"
                                                        type="text"
                                                        value={item.recoOpticianRightSPH || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianRightCYL"
                                                        type="text"
                                                        value={item.recoOpticianRightCYL || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianRightAXIS"
                                                        type="text"
                                                        value={item.recoOpticianRightAXIS || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianRightADD"
                                                        type="text"
                                                        value={item.recoOpticianRightADD || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianRightPD"
                                                        type="text"
                                                        value={item.recoOpticianRightPD || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>OG</td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianLeftSPH"
                                                        type="text"
                                                        value={item.recoOpticianLeftSPH || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianLeftCYL"
                                                        type="text"
                                                        value={item.recoOpticianLeftCYL || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianLeftAXIS"
                                                        type="text"
                                                        value={item.recoOpticianLeftAXIS || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianLeftADD"
                                                        type="text"
                                                        value={item.recoOpticianLeftADD || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        name="recoOpticianLeftPD"
                                                        type="text"
                                                        value={item.recoOpticianLeftPD || ''}
                                                        placeholder={t('inputText')}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        )}

                        <Card className="mb-3 eye_test_symtoms">
                            <Card.Body className="modal_form">
                                <Card.Title className="add_eye_title">
                                    <h4 className="mb-3">{t('commandes')}</h4>
                                </Card.Title>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>SPH</th>
                                            <th>CYL</th>
                                            <th>AXE</th>
                                            <th>ADD</th>
                                            <th>PD</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OD</td>
                                            <td>
                                                <Select
                                                    options={SPH}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderRightSPH,
                                                        label: item.orderRightSPH,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderRightSPH', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={CYL}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderRightCYL,
                                                        label: item.orderRightCYL,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderRightCYL', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={AXE}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderRightAXIS,
                                                        label: item.orderRightAXIS,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderRightAXIS', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={ADD}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderRightADD,
                                                        label: item.orderRightADD,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderRightADD', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={PD}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderRightPD,
                                                        label: item.orderRightPD,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderRightPD', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>OG</td>
                                            <td>
                                                <Select
                                                    options={SPH}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderLeftSPH,
                                                        label: item.orderLeftSPH,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderLeftSPH', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={CYL}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderLeftCYL,
                                                        label: item.orderLeftCYL,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderLeftCYL', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={AXE}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderLeftAXIS,
                                                        label: item.orderLeftAXIS,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderLeftAXIS', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={ADD}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderLeftADD,
                                                        label: item.orderLeftADD,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderLeftADD', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={PD}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.orderLeftPD,
                                                        label: item.orderLeftPD,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'orderLeftPD', item.OrderPairNo)
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                {(error[index]?.orderLeftPD || error[index]?.orderRightPD) && (
                                    <Alert variant="danger">
                                        {t('mustEnterValue')}
                                    </Alert>
                                )}
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('hauteurPup')} OD*
                                            </Form.Label>
                                            <Form.Control
                                                name="rightHeightEye"
                                                type="text"
                                                value={item.rightHeightEye || ''}
                                                onChange={(e) =>
                                                    handleChange(e.target.value, 'rightHeightEye', item.OrderPairNo)
                                                }
                                                placeholder={t('inputText')}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('hauteurPup')} OG*
                                            </Form.Label>
                                            <Form.Control
                                                name="leftHeightEye"
                                                type="text"
                                                value={item.leftHeightEye || ''}
                                                onChange={(e) =>
                                                    handleChange(e.target.value, 'leftHeightEye', item.OrderPairNo)
                                                }
                                                placeholder={t('inputText')}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="mb-3">
                            <Card.Body className="modal_form">
                                {index === 0 && (
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group className={`mb-3 ${error[index]?.lensShape ? 'error_input' : ''}`}>
                                                <Form.Label>
                                                    {t('typeDePanier')}*
                                                </Form.Label>
                                                <Select
                                                    options={Typedepanier}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.lensShape,
                                                        label: item.lensShape,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'lensShape', item.OrderPairNo)
                                                    }
                                                />
                                                {error[index]?.lensShape && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group className={`mb-3 ${error[index]?.tiersPayant ? 'error_input' : ''}`}>
                                                <Form.Label>
                                                    {t('tiersPayant')}*
                                                </Form.Label>
                                                <Select
                                                    options={TiersPayant}
                                                    noOptionsMessage={() => t('noOptionMessage')}
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.tiersPayant,
                                                        label: item.tiersPayant,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(value, 'tiersPayant', item.OrderPairNo)
                                                    }
                                                />
                                                {error[index]?.tiersPayant && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group
                                                className={`mb-3 ${error[index]?.typeofpayment ? 'error_input' : ''}`}
                                            >
                                                <Form.Label>
                                                    {t('typeOfPayment')}*
                                                </Form.Label>
                                                <Select
                                                    options={Typeofpayment}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    menuPosition="fixed"
                                                    className="details_select custom_select"
                                                    value={{
                                                        value: item.typeofpayment,
                                                        label: item.typeofpayment,
                                                    }}
                                                    onChange={({ value }) =>
                                                        handleChange(
                                                            value,
                                                            'typeofpayment',
                                                            item.OrderPairNo
                                                        )
                                                    }
                                                />
                                                {error[index]
                                                    ?.typeofpayment && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t('mustEnterValue')}
                                                        </Form.Control.Feedback>
                                                    )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                <Card.Title>
                                    <h4 className="mb-3">
                                        Pair - {item.OrderPairNo}
                                    </h4>
                                </Card.Title>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.typeDeVision ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('typeofVision')}*
                                            </Form.Label>
                                            <Select
                                                options={Typedevision}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.typeDeVision,
                                                    label: item.typeDeVision,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'typeDeVision',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.typeDeVision && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.orderType ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('typeDeVerres')}*
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'orderType',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.orderType,
                                                    label: item.orderType,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'orderType',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.orderType && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.orderIndex ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('indice')}*
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'orderIndex',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.orderIndex,
                                                    label: item.orderIndex,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'orderIndex',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.orderIndex && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('couleur')}
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'frameColor',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.frameColor,
                                                    label: item.frameColor,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'frameColor',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('optionDeVerre')}
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'lensTypeDetails',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.lensTypeDetails,
                                                    label: item.lensTypeDetails,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'lensTypeDetails',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.treatment ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('traitement')}*
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'treatment',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.treatment,
                                                    label: item.treatment,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'treatment',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.treatment && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.infoFrameType ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('typeDeMonture')}*
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'frameType',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.infoFrameType,
                                                    label: item.infoFrameType,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'infoFrameType',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.infoFrameType && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.frameReference ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('monture')}*
                                            </Form.Label>
                                            <Select
                                                options={getPairSpecificOptions(
                                                    item.OrderPairNo,
                                                    'frameReference',
                                                    item
                                                )}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.frameReference,
                                                    label: item.frameReference,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'frameReference',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.frameReference && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group
                                            className={`mb-3 ${error[index]?.infoSupplier ? 'error_input' : ''}`}
                                        >
                                            <Form.Label>
                                                {t('fournisseur')}*
                                            </Form.Label>
                                            <Select
                                                options={Supplier}
                                                noOptionsMessage={() =>
                                                    t('noOptionMessage')
                                                }
                                                menuPosition="fixed"
                                                className="details_select custom_select"
                                                value={{
                                                    value: item.infoSupplier,
                                                    label: item.infoSupplier,
                                                }}
                                                onChange={({ value }) =>
                                                    handleChange(
                                                        value,
                                                        'infoSupplier',
                                                        item.OrderPairNo
                                                    )
                                                }
                                            />
                                            {error[index]?.infoSupplier && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t('mustEnterValue')}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('prix')}</Form.Label>
                                            <Form.Control
                                                name="price"
                                                type="text"
                                                value={item.price || '0.00 €'}
                                                placeholder={t('inputText')}
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={8}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('commentaireSurLaCommande')}
                                            </Form.Label>
                                            <Form.Control
                                                name="comments"
                                                type="text"
                                                value={item.comments}
                                                onChange={(e) =>
                                                    handleChange(
                                                        e.target.value,
                                                        'comments',
                                                        item.OrderPairNo
                                                    )
                                                }
                                                placeholder={t('inputText')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Stack direction="horizontal" gap={3}>
                                            <div>
                                                <Form.Label>
                                                    {t('status')}
                                                </Form.Label>
                                                <div className="">
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name={`status_${index}`}
                                                        value="Pending"
                                                        onChange={(e) =>
                                                            handleChange(
                                                                e.target.value,
                                                                'status',
                                                                item.OrderPairNo
                                                            )
                                                        }
                                                        checked={
                                                            item.status ===
                                                            'Pending'
                                                        }
                                                        label={t('pending')}
                                                        id={`pending_${index}`}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        value="SAV"
                                                        name={`status_${index}`}
                                                        onChange={(e) =>
                                                            handleChange(
                                                                e.target.value,
                                                                'status',
                                                                item.OrderPairNo
                                                            )
                                                        }
                                                        checked={
                                                            item.status ===
                                                            'SAV'
                                                        }
                                                        label={t('savStatus')}
                                                        id={`sav_${index}`}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name={`status_${index}`}
                                                        value="Devis"
                                                        onChange={(e) =>
                                                            handleChange(
                                                                e.target.value,
                                                                'status',
                                                                item.OrderPairNo
                                                            )
                                                        }
                                                        checked={
                                                            item.status ===
                                                            'Devis'
                                                        }
                                                        label={t('devisStatus')}
                                                        id={`devis_${index}`}
                                                    />
                                                </div>
                                            </div>
                                        </Stack>
                                    </Col>

                                    {/* Pair visibility controls */}
                                    {index === 0 && (
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('newPair2')}
                                                </Form.Label>
                                                <div>
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="secondPair"
                                                        value="yes"
                                                        onChange={() => handleTogglePair(1, true)}
                                                        checked={showPairs[1]}
                                                        label={t('yes')}
                                                        id="secondPairYes"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="secondPair"
                                                        value="no"
                                                        onChange={() => handleTogglePair(1, false)}
                                                        checked={!showPairs[1]}
                                                        label={t('no')}
                                                        id="secondPairNo"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}

                                    {index === 1 && showPairs[1] && (
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('newPair3')}
                                                </Form.Label>
                                                <div>
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="thirdPair"
                                                        value="yes"
                                                        onChange={() => handleTogglePair(2, true)}
                                                        checked={showPairs[2]}
                                                        label={t('yes')}
                                                        id="thirdPairYes"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="thirdPair"
                                                        value="no"
                                                        onChange={() => handleTogglePair(2, false)}
                                                        checked={!showPairs[2]}
                                                        label={t('no')}
                                                        id="thirdPairNo"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}

                                    {index === 2 && showPairs[2] && (
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('newPair4')}
                                                </Form.Label>
                                                <div>
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="fourthPair"
                                                        value="yes"
                                                        onChange={() => handleTogglePair(3, true)}
                                                        checked={showPairs[3]}
                                                        label={t('yes')}
                                                        id="fourthPairYes"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        name="fourthPair"
                                                        value="no"
                                                        onChange={() => handleTogglePair(3, false)}
                                                        checked={!showPairs[3]}
                                                        label={t('no')}
                                                        id="fourthPairNo"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </Card.Body>
                </Card>
            ))}

            {/* Total Price Field - Displayed only once at the bottom */}
            {addOrderConfig.length > 0 && (
                <Card className="mt-4">
                    <Card.Body className="modal_form">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <strong>{t('totalPrice')}</strong>
                                    </Form.Label>
                                    <Form.Control
                                        name="totalPrice"
                                        type="text"
                                        value={calculateTotalPrice()}
                                        placeholder={t('inputText')}
                                        disabled
                                        readOnly
                                        className="fw-bold"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )}
        </>
    );
};

export default OrderPair;